import { useEffect } from "react";

function Fancybox(props) {
  const delegate = props.delegate || "[data-fancybox]";

  useEffect(() => {
    if (typeof window === "undefined") return;

    const loadAndInitFancybox = async () => {
      try {
        const { Fancybox: NativeFancybox } = await import("@fancyapps/ui");

        const opts = props.options || {};

        if (NativeFancybox && NativeFancybox.bind) {
          NativeFancybox.bind(delegate, opts);
        }

        return () => {
          if (NativeFancybox && NativeFancybox.destroy) {
            NativeFancybox.destroy();
          }
        };
      } catch (error) {
        console.warn("FancyBox could not be loaded:", error);
        return () => {};
      }
    };

    let cleanup: Promise<() => void>;
    cleanup = loadAndInitFancybox();

    return () => {
      cleanup.then((fn) => fn && fn());
    };
  }, [delegate, props.options]);

  return <>{props.children}</>;
}

export default Fancybox;
